import { BrainCircuit, Crosshair, Layers, TrendingUp } from "lucide-react";
import { Reveal } from "./Reveal";

const REASONS = [
  {
    icon: BrainCircuit,
    title: "AI-POWERED",
    desc: "Modern production without sacrificing strategy.",
  },
  {
    icon: Crosshair,
    title: "STRATEGY-FIRST",
    desc: "Every creative decision has a purpose.",
  },
  {
    icon: Layers,
    title: "ONE PARTNER",
    desc: "Brand, content, digital and growth under one roof.",
  },
  {
    icon: TrendingUp,
    title: "BUILT FOR GROWTH",
    desc: "We don't stop at making things look good.",
  },
];

export const Trust = () => (
  <section data-testid="trust-section" className="relative py-24 lg:py-32 border-t border-white/[0.05]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#8B2CFF] mb-6 text-center">
          Why Brands Choose BrandZenith
        </p>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.1} className="h-full">
            <div
              data-testid={`trust-card-${i}`}
              className="group h-full text-center glass-card rounded-lg p-8 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-[#6D00FF]/40 hover:shadow-[0_0_40px_-12px_rgba(109,0,255,0.5)]"
            >
              <div className="w-12 h-12 mx-auto rounded-md border border-white/10 flex items-center justify-center mb-6 transition-[border-color,box-shadow] duration-500 group-hover:border-[#8B2CFF]/60 group-hover:shadow-[0_0_20px_-4px_rgba(139,44,255,0.6)]">
                <r.icon className="w-5 h-5 text-[#8B2CFF] group-hover:text-[#C43CFF] transition-colors duration-500" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.18em] mb-3">
                {r.title}
              </h3>
              <p className="text-sm text-[#A6A6B0] leading-relaxed">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
